import api from 'api'
import { AxiosPromise, AxiosRequestConfig } from 'axios'

export function salvarAnexoArquivo(formData: FormData, config: AxiosRequestConfig): AxiosPromise<string> {
  return api.anexoArquivos.salvarArquivo(formData, config)
}
